import {ScaleLinear} from 'd3';
import _ from 'underscore';

import {getSelectionMenu} from 'components/SelectionContextMenu';
import SearchDNAData from 'molbio/biological-search/SearchDNAData';
import {DNASearchResult} from 'molbio/biological-search/SearchModels';
import {SearchLayout} from 'molbio/maps/circular/CircularLayout';
import SegmentsRingView from 'molbio/maps/circular/SegmentsRingView';

class SearchResultsView extends SegmentsRingView<SearchLayout, DNASearchResult> {
  singularClassName = 'dnaSearch';

  static initClass(): void {
    this.prototype.className = 'dnaSearches';
    this.prototype.singularClassName = 'dnaSearch';
    this.prototype.tagName = 'g';
  }

  override contextMenuData(): Array<string> {
    return getSelectionMenu();
  }

  override fill(d: DNASearchResult): string {
    if (d.get('selected')) {
      return 'orange';
    } else {
      return 'yellow';
    }
  }
  override opacity(): number {
    return 0.4;
  }
  override strokeWidth(): number {
    return 1.0;
  }
  override stroke(): string {
    return 'black';
  }

  override data(): Array<DNASearchResult> {
    const sequence = this.model.get('sequence');
    const length = sequence.length();
    return SearchDNAData.get()
      .get('results')
      .slice(0, length, sequence, SearchDNAData.get().get('onlyShowSelected'));
  }

  override updateRadius(): ScaleLinear<number, number> {
    return this.radius.range([this.getInnerRadius() - 5, this.layout.get('DNA')!.get('outerRadius') + 5]);
  }

  override updateLayers(data: Array<DNASearchResult>): void {
    // eslint-disable-next-line no-restricted-syntax
    _.each(data, (datum) => datum.set({annularLayer: 0}));
    this.layout.set('outerRadius', this.getInnerRadius());
  }

  override registerListeners(): void {
    super.registerListeners();
    const results = SearchDNAData.get().get('results');

    this.listenTo(results, 'change:selected', (model: DNASearchResult, value: boolean) => {
      if (SearchDNAData.get().get('onlyShowSelected')) {
        this.update();
      } else {
        this.handleHover(model, value);
      }
    });
    return this.listenTo(results, 'reset', () => {
      this.updateData();
      this.update();
    });
  }

  clickAction(_: Event, d: DNASearchResult): void {
    d.click(this.model.get('sequence'), false);
  }

  dblClickAction(_: Event, d: DNASearchResult): void {
    d.dblClick(this.model.get('sequence'), false);
  }

  override redraw(): void {
    this.invalidateData();
    super.redraw();
  }
}
SearchResultsView.initClass();

export default SearchResultsView;
